import { useCallback, useEffect, useMemo, useState } from "react";
import { DashboardService } from "../../../../../services/dashboard";
import dayjs from "../../../../../configs/dayjs";
import { useXAxisFormat } from "../../../hooks/useXAxisFormat";

export const useFetchData = (
  granularity: number,
  isRecalculated: boolean,
  codes: string[],
  toolTipName: string,
) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [data, setData] = useState<any>(null);

  const kpiCode = useMemo(() => {
    if (granularity === 1) {
      return codes[0];
    } else if (granularity === 2) {
      return codes[1];
    }

    return codes[2];
  }, [codes, granularity]);

  const { xAxisFormat, tooltipFormat } = useXAxisFormat(granularity);

  const fetchData = useCallback(async () => {
    try {
      setIsLoading(true);

      const res: any = await DashboardService.fetchHistory({
        granularity,
        kpiCode,
      });

      const result = res[0].kpiValues
        .map((item: any) => ({
          xAxis: dayjs(item.createdAt).format(xAxisFormat),
          value: item.value,
          tooltipHeader: dayjs(item.createdAt).format(tooltipFormat),
          toolTipName,
        }))
        .reverse();

      setData(result);

      setIsLoading(false);
    } catch {
      setIsLoading(false);
    }
  }, [granularity, kpiCode, tooltipFormat, xAxisFormat, toolTipName]);

  useEffect(() => {
    fetchData();
  }, [fetchData, isRecalculated]);

  return { isLoading, data };
};
